import React, {useEffect, useRef, useState} from "react";
import axios from '../../services/axiosInstance';
import {BiCaretDown} from "react-icons/bi";
import {BsTrash} from "react-icons/bs";
import reviewUpload from '../../assets/img/reviewUpload.png';
import {useNavigate} from "react-router-dom";
import withAuth from '../../auth/UserRouteAuth'
import {useTranslation} from "react-i18next";
import {useWebSocket} from "../../services/WebsocketContext";
import commomHeader from "../../assets/img/commonHeader.png";
import commonClose from "../../assets/img/commonClose.png";
import receivedComplete from "../../assets/img/receivedComplete.png";
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";
import "../../css/web/UserReviewRenew.css";

function UserReviewWritePg() {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [theme] = useTheme();
    const SSAT = sessionStorage.getItem('AToken');
    const LCAT = localStorage.getItem('AToken');

    const [ordNumErrorMsg, setOrdNumErrorMsg] = useState(false);
    const [titleErrorMsg, setTitleErrorMsg] = useState(false);
    const [reviewErrorMsg, setReviewErrorMsg] = useState(false);

    /* 국가/이용배송사 양식은 사용자 입력에서 생략.
       선택한 주문번호(주문번호-박스번호) 기준으로 백엔드에서 조회·맵핑하여 저장한다. */

    const [memberInfo, setMemberInfo] = useState("");
    const findMember = (() => {
        axios({
            method: 'get',
            url: '/member/findMember',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                setMemberInfo(response.data)
            })
            .catch(() => {
                console.log("멤버조회 실패")
            })
    })

    useEffect(() => {
        if (SSAT || LCAT) {
            findMember();
            selectedReviewPayOrder();
        }
    }, [SSAT, LCAT])

    // 웹소켓
    const isSubscribedRef = useRef(false);
    const {subscribe, unsubscribe, websocketConnect, isConnected, stompClient} = useWebSocket();

    useEffect(() => {
        const initializeConnection = async () => {
            if (!memberInfo.mbNum || isSubscribedRef.current) return;
            if (!stompClient && !isConnected) {
                await websocketConnect(memberInfo.mbNum);
            }
            if (isConnected && stompClient && !isSubscribedRef.current) {
                isSubscribedRef.current = true;
            }
        }

        initializeConnection();

        return () => {
            if (isSubscribedRef.current) {
                isSubscribedRef.current = false;
            }
        };

    }, [memberInfo.mbNum, isConnected, stompClient]);

    const [ordNumList, setOrdNumList] = useState([]);
    const [selectedOrdNum, setSelectedOrdNum] = useState('');
    const selectedReviewPayOrder = () => {
        axios({
            method: 'get',
            url: '/review/selectedReviewPayOrder',
            headers: {
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then((response) => {
                setOrdNumList(response.data);
            })
    }

    // 여기서부터 커스텀 셀렉트
    const [ordNumShow, setOrdNumShow] = useState(false);
    const ordNumRef = useRef(null);

    const toggleOrdNumShow = () => {
        setOrdNumShow(!ordNumShow);
    };

    const handleOrdNumChange = (ordNum) => {
        setSelectedOrdNum(ordNum);
        setOrdNumShow(false);
        setOrdNumErrorMsg(false);
    };

    useEffect(() => {
        function handleClickOutside(event) {
            if (ordNumRef.current && !ordNumRef.current.contains(event.target)) {
                setOrdNumShow(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    // 여기까지 커스텀 셀렉트

    const [titleText, setTitleText] = useState('');
    const handleChangeTitleText = (e) => {
        setTitleText(e.target.value);
        setTitleErrorMsg(false);
    };

    const [reviewText, setReviewText] = useState('');
    const handleChangeReviewText = (e) => {
        setReviewText(e.target.value);
        setReviewErrorMsg(false);
    };


    const [reviewContainers, setReviewContainers] = useState([{
        reviewImg: reviewUpload,
        reviewImgSt: false,
        reviewImgError: false
    }]);
    const reviewImgHandle = (idx) => (e) => {
        const file = e.target.files[0];

        if (file) {
            setReviewContainers((prev) => {
                const newContainers = [...prev];

                if (!file.type.startsWith('image/')) {
                    newContainers[idx] = {
                        ...newContainers[idx],
                        reviewImgError: true,
                    };
                    return newContainers;
                } else {
                    newContainers[idx] = {
                        ...newContainers[idx],
                        reviewImg: URL.createObjectURL(file),
                        reviewImgSt: true,
                        reviewImgError: false,
                        file: file
                    };
                    if (idx === newContainers.length - 1) {
                        addForm(newContainers);
                    }
                    return newContainers;
                }
            });
        }
    };

    const reviewImgInit = (idx) => () => {
        setReviewContainers((prev) => {
            const newContainers = [...prev];

            newContainers.splice(idx, 1);

            const lastContainer = newContainers[newContainers.length - 1];
            if (lastContainer && lastContainer.reviewImgSt) {
                newContainers.push({reviewImg: reviewUpload, reviewImgSt: false, reviewImgError: false});
            }

            return newContainers;
        });
        // formData.delete('reviewImg');
    };


    const addForm = (newContainers) => {
        const lastContainer = newContainers[newContainers.length - 1];
        if (!lastContainer.reviewImgSt) {
            return;
        }

        newContainers.push({reviewImg: reviewUpload, reviewImgSt: false, reviewImgError: false});
    };

    const validation = () => {
        if (selectedOrdNum === '' || !selectedOrdNum) setOrdNumErrorMsg(true);
        if (titleText === '' || !titleText) setTitleErrorMsg(true);
        if (reviewText === '' || !reviewText) setReviewErrorMsg(true);
        return !!(selectedOrdNum && titleText && reviewText)
    }


    const [isSaveBtLoading, setIsSaveBtLoading] = useState(false);
    const [pointPayCompleteMsg, setPointPayCompleteMsg] = useState(false);
    const [pointPayErrorMsg, setPointPayErrorMsg] = useState(false);
    const [reviewDtPgSeqNum, setReviewDtPgSeqNum] = useState(false);

    const reviewSave = () => {
        setIsSaveBtLoading(true);

        const newFormData = new FormData();
        // 국가/이용배송사는 전송하지 않는다. (백엔드에서 주문번호-박스번호 기준으로 조회·맵핑하여 저장)
        newFormData.append('orderNumber', selectedOrdNum);
        newFormData.append('title', titleText);
        newFormData.append('reviewText', reviewText);

        reviewContainers.forEach((container, idx) => {
            if (container.file) {
                newFormData.append('reviewImg', container.file);
            }
        });

        return axios({
            method: 'post',
            url: '/review/reviewSave',
            data: newFormData,
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: LCAT ? LCAT : SSAT
            },
        })
            .then(async (response) => {
                const data = response.data
                setReviewDtPgSeqNum(data.seqNum);
                await saveReviewAlarmData(data);
                if (data.pointPayFl) {
                    setPointPayCompleteMsg(true);
                } else {
                    setPointPayErrorMsg(true);
                }
            })
            .catch((error) => {
                console.log("후기저장오류 : ", error)
                setIsSaveBtLoading(false);
            })
            .finally(() => {
                setIsSaveBtLoading(false);
            })
    }

    const saveReviewAlarmData = ((reviewData) => {
        axios({
            method: 'post',
            url: '/order/saveReviewData',
            headers: {
                Authorization: LCAT ? LCAT : SSAT,
                'Content-Type': 'application/json',
            },
            data: reviewData
        })
            .then(async () => {
                await stompClient.send("/app/reviewAlarm", {}, JSON.stringify({sendFl: true}));
            })
            .catch((error) => {
                console.log("알림데이터 저장실패 : ", error)
            })
    })

    const moveToReviewDt = (seqNum) => {
        navigate(`/UserReviewDetailPg/${seqNum}`);
    }

    const valiAndSave = () => {
        if (validation()) {
            reviewSave();
        } else {
            setIsSaveBtLoading(false);
        }
    }

    const [unableToWriteMsg, setUnableToWriteMsg] = useState(false);
    const closeUnableToWriteMsg = () => {
        setUnableToWriteMsg(false);
    }


    return (
        <div className="up-scope up-page font-t-cont" data-theme={theme}>
            <div className="up-head">
                <div className="up-head-l">
                    <img className="up-head-icon up-invert" src={commomHeader} alt="header"/>
                    <p className="up-head-title">{t(`rvWtHeader`)}</p> {/*이용후기작성*/}
                </div>
            </div>
            <div className="m-t-5 p-t-10">
                {/*제목 / 주문번호 (국가·이용배송사는 주문번호 기준 백엔드 자동맵핑으로 생략)*/}
                <div className="font-t-cont rv-write-filter">
                    {/*제목*/}
                    <div className="rvw-field rvw-field-title">
                        <div className="ReviewPgSearchFrame acc-icon">
                            <div className="ReviewPgInputForm" style={{width: "100%", boxSizing: "border-box"}}>
                                <input className="ReviewInput user-input"
                                       style={{width: "100%", paddingLeft: "10px", height: "100%", boxSizing: "border-box"}} type="text"
                                       placeholder="" value={titleText} maxLength={35}
                                       onChange={handleChangeTitleText}/>
                                <label className="JoinLabel" style={{fontSize: "14px"}}>{t(`rvWtTp`)}</label>
                            </div>
                        </div>
                        {titleErrorMsg ?
                            <div className="JoinErrorMsg">
                                <p className="JoinErrMsg">{t(`rvWtErr3`)}</p>
                            </div>
                            :
                            null
                        }
                    </div>

                    {/*작성 가능한 주문서리스트*/}
                    <div className="rvw-field rvw-field-ord">
                        {/*여기서부터 커스텀 주문서셀렉트*/}
                        <div ref={ordNumRef} style={{height: "55px", width: "100%", position: "relative"}}>
                            <button className="selectParentBt" style={{width: "100%", height: "100%"}}
                                    onClick={() => {
                                        if (ordNumList.length > 0) {
                                            toggleOrdNumShow();
                                        } else {
                                            setUnableToWriteMsg(true);
                                        }
                                    }}>
                                <p style={{margin: "0"}} className="font-s-14">{selectedOrdNum === "" ? t('modNum') : selectedOrdNum}</p>
                                <span
                                    style={{position: "absolute", left: "80%", top: "0", height: "100%", width: "20%"}}>
                                <i style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%"
                                }}><BiCaretDown/></i>
                            </span>
                            </button>
                            {ordNumShow ? (
                                <div style={{
                                    width: "100%",
                                    border: "solid 1px lightgray",
                                    position: "relative", // absolute → relative 변경
                                    marginTop: "5px",
                                    zIndex: 1000
                                }}>
                                    {ordNumList.map((order, index) => (
                                        <div className="selectChildColorBt" key={index} value={order}
                                             onClick={() => handleOrdNumChange(order)}
                                             style={{
                                                 display: "flex",
                                                 padding: "10px",
                                                 justifyContent: "center",
                                                 alignItems: "center",
                                                 cursor: "pointer",
                                                 fontSize: "14px",
                                             }}>
                                            <img className="wd-25 ht-25 m-r-10" src={receivedComplete} alt="Order"/>
                                            <p>{order}</p>
                                        </div>
                                    ))}
                                </div>
                            ) : null}
                        </div>
                        {/*여기까지 커스텀 주문서셀렉트*/}

                        {ordNumErrorMsg ?
                            <div className="JoinErrorMsg">
                                <p className="JoinErrMsg">{t(`rvWtErr4`)}</p>
                            </div>
                            :
                            null
                        }
                    </div>

                </div>

                <div className="rv-write-split" style={{height: "auto", display: "flex", marginTop: "20px"}}>
                    <div className="rv-write-main" style={{width: "65%"}}>
                        <div className="ordChatInputContainer" style={{height: "100%", minHeight: "600px"}}>
                    <textarea
                        placeholder={t(`myCont`)}
                        spellCheck="false"
                        value={reviewText}
                        maxLength={10000}
                        style={{
                            borderRadius: "6px",
                            height: "100%",
                            width: "100%",
                            borderWidth: "thin 1px",
                            borderColor: "var(--up-border-2)",
                            resize: "none",
                            overflow: "auto",
                            outline: "none",
                            color: "var(--up-text)",
                            padding: "18px",
                            fontSize: "14px",
                            ':focus': {
                                borderColor: "orange"
                            },
                        }} onChange={handleChangeReviewText}/>
                        </div>
                        <div className="JoinErrorMsg">
                            {reviewErrorMsg && <p className="JoinErrMsg">{t(`rvWtErr1`)}</p>}
                        </div>
                    </div>
                    <div className="rv-write-side" style={{width: "35%", paddingLeft: "10px"}}>
                        {reviewContainers.map((container, idx) => (
                            <div key={idx} style={{
                                border: "solid",
                                height: "305px",
                                borderWidth: "thin 1px",
                                borderColor: "var(--up-border-2)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                {!container.reviewImgSt ?
                                    <div style={{display: "block", textAlign: "center", cursor: "pointer"}}
                                         onClick={(e) => {
                                             const parentDiv = e.target.parentNode;
                                             const fileInput = parentDiv.querySelector('input[type="file"]');
                                             if (fileInput) fileInput.click();
                                         }}>
                                        <input type="file" accept="image/*" style={{display: "none"}}
                                               onChange={reviewImgHandle(idx)}/>
                                        <img alt="uploadImg" style={{
                                            width: "80px",
                                            height: "80px",
                                            padding: "10px",
                                            filter: "opacity(0.2) drop-shadow(0 0 0 gray)",
                                        }} src={container.reviewImg}/>
                                        <p style={{color: "rgba(112,112,109,0.67)", fontSize: "18px"}}>Click me !</p>
                                        <div className="JoinErrorMsg">
                                            {container.reviewImgError && <p className="JoinErrMsg">{t(`rvWtErr2`)}😅</p>}
                                        </div>
                                    </div>
                                    :
                                    <div style={{width: "90%", display: "flex", height: "90%", position: "relative"}}>
                                        <img alt="reviewImg" style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                        }} src={container.reviewImg}/>

                                        {/*focus나 active X*/}
                                        <button
                                            className="user-center border-bt-none position-absolute wd-40 ht-40 border-rd4"
                                            style={{
                                                bottom: 0,
                                                right: 0,
                                                opacity: 0.6,
                                                backgroundColor:"#FFAF34",
                                                color:"white"
                                            }}
                                            onClick={reviewImgInit(idx)}
                                        >
                                            <BsTrash size={22}/>
                                        </button>
                                    </div>
                                }
                            </div>
                        ))}

                    </div>
                </div>
                <div style={{
                    height: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "end"
                }}>
                    <style>
                        {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
                    </style>
                    <button disabled={isSaveBtLoading} className="bt-btn-B wd-100 ht-45 font-s-15"
                            onClick={valiAndSave}>
                        {isSaveBtLoading ? (
                            <div className="spinner"></div>
                        ) : (
                            <div>{t(`rvdtBt`)}</div>
                        )}
                    </button>
                </div>
            </div>

            {pointPayCompleteMsg ?
                <MsgCheckModal pointPayCompleteMsg={pointPayCompleteMsg}
                               moveToReviewDt={moveToReviewDt}
                               reviewDtPgSeqNum={reviewDtPgSeqNum}/>
                :
                pointPayErrorMsg ?
                    <MsgCheckModal pointPayErrorMsg={pointPayErrorMsg}
                                   moveToReviewDt={moveToReviewDt}
                                   reviewDtPgSeqNum={reviewDtPgSeqNum}/>
                    :
                    unableToWriteMsg ?
                        <MsgCheckModal unableToWriteMsg={unableToWriteMsg}
                                       closeUnableToWriteMsg={closeUnableToWriteMsg}/>
                        :
                    null
            }

        </div>
    )
}

export default withAuth(UserReviewWritePg)
